module.exports = __webpack_public_path__ + "img/cmdb6.6dce18a5.png";